import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const EntityPointerSchema = z
    .object({
        tenantId: z.string(),
        entityId: z.string(),
    })
    .strict();

export class EntityPointer extends FromSchema(EntityPointerSchema) {
    tenantId: string;
    entityId: string;
}
